import script from "./PromotionMenuComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionMenuComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QRouteTab,QBtnDropdown,QList,QItem,QItemSection});
